import {create} from 'zustand'

export const usePasswordModalStore = create((set) => ({
    open: false,
    showPasswordModal: () => set(() => ({open: true})),
    hidePasswordModal: () => set(() => ({open: false})),
}));